// SPEC-029 (RR4 #5): a labelled wrapper for one QC-lifecycle phase (Analyst / Reviewer / QA) in the
// "QC Results & Approvals" panel. All three phases are ALWAYS rendered (GMP/ALCOA+: the whole team
// SEES the full lifecycle); the phase the current user can act on NOW is highlighted (`active`), the
// others are visibly dimmed/ghosted. `empty` renders a neutral placeholder when the phase has no
// content yet. Purely presentational — the per-control act-gates (canSign) still govern who can act.
export default function PhaseSection({ title, stepLabel = null, active = false, empty = false, hint = null, children }) {
  const className = [
    "ResultEntryPanel-phase",
    active ? "is-active" : "is-ghosted",
    empty ? "is-empty" : "",
  ]
    .filter(Boolean)
    .join(" ")
  return (
    <section className={className}>
      <header className="ResultEntryPanel-phase-head">
        {stepLabel && <span className="ResultEntryPanel-phase-step">{stepLabel}</span>}
        <h4 className="ResultEntryPanel-phase-title">{title}</h4>
        {hint && <span className="ResultEntryPanel-phase-hint">{hint}</span>}
      </header>
      <div className="ResultEntryPanel-phase-body">{children}</div>
    </section>
  )
}
